<template>
  <div class="login px-1 bg-light pt-5">
    <div class="mx-auto px-4 kovatek-login border shadow-lg pt-2 bg-white mb-5">
      <form class="py-3 px-md-2 mx-auto" @submit="resetHandler($event)">
        <div class="">
          <router-link to="/">
            <img
              class="navbar-brand logo-size my-4 "
              src="/images/logo.png"
              alt="TalentAlt"
            />
          </router-link>
          <div class="alert alert-success" v-if="message">
            <strong>{{ message }}</strong>
          </div>
          <div class="my-3">
            <input
              type="password"
              class="form-control input-height"
              id="email"
              placeholder="Password"
              v-model="password"
              required
            />
          </div>
          <div class="my-3">
            <input
              type="password"
              class="form-control input-height"
              id="email"
              placeholder="Confirm Password"
              v-model="confirmPassword"
              required
            />
          </div>
        </div>
        <div class="m-auto">
          <button class="btn btn-kovatek mt-3 w-100 mb-4" type="submit">
            Reset Password
          </button>
          <p class="text-danger font-weight-bolder" v-if="error">{{ error }}</p>
        </div>
        <!-- <a-divider /> -->
        <p>
          New to kovatek?
          <router-link to="/register" class="font-weight-bold kova-text"
            ><a>Create an account</a></router-link
          >
        </p>
        <!-- <p>Haven't verify account? <router-link to="/token" class="font-weight-bold kova-text"><a>Request verification email</a></router-link> </p> -->
      </form>
    </div>
    <!-- </div> -->
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer.vue';
export default {
  name: 'reset_password',
  components: {
    Footer,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      message: '',
      error: null,
    };
  },
  computed: {
    isLoggedIn: () => {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    resetHandler(event) {
      event.preventDefault();
      const { password, confirmPassword } = this;
      const isValid =
        password === '' ||
        confirmPassword === '' ||
        password !== confirmPassword;

      if (!isValid) {
        //YYrdbQWBP7LxIzihRKrM8k4EhpibzfDNZXyNHnW1RGk%3D
        const data = {
          token: this.$route.query.token,
          password: password,
        };
        // console.log(data)

        this.$store
          .dispatch('resetPassword', data)
          .then((resp) => {
            // console.log(resp, resp.data)
            this.message = resp.data;
          })
          .catch((err) => {
            // console.log("got error "+err)
            this.error = err.message;
          });
      } else {
        this.error = 'invalid or incomplete inputs';
      }
    },
  },
};
</script>
<style scoped>
.input-title {
  margin-left: 25px;
  font-size: 13px;
}

.logo-size {
  height: 45px;
}

.kovatek-login {
  width: 600px;
}
.add-grey {
  background-color: #ddd;
}
.add-grey:hover {
  background-color: #ccc;
}
.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}

.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.icon-size {
  font-size: 20px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .kovatek-login {
    width: 400px;
  }
  .input-height {
    font-size: 16px;
  }
}

@media (max-width: 450px) {
  .kovatek-login {
    width: 100%;
  }
}
</style>
